import { usePrimaryEnvironmentDescriptor } from "../environments/primary";
import { useSavedEnvironmentRuntimeStore } from "../environments/runtime/savedEnvironmentRuntimeStore";

export interface PullRequestEnvironmentCandidate {
  readonly connectionState: "connecting" | "connected" | "disconnected" | "error";
  readonly capabilities: { readonly pullRequests?: boolean } | null;
}

export function shouldShowPullRequestsNavigation(
  candidates: ReadonlyArray<PullRequestEnvironmentCandidate>,
  commandAvailable = false,
): boolean {
  return (
    commandAvailable ||
    candidates.some(
      (candidate) =>
        candidate.connectionState === "connected" && candidate.capabilities?.pullRequests === true,
    )
  );
}

export function useHasPullRequestCapableEnvironment(): boolean {
  const primaryDescriptor = usePrimaryEnvironmentDescriptor();
  const savedRuntimeById = useSavedEnvironmentRuntimeStore((state) => state.byId);
  const candidates: PullRequestEnvironmentCandidate[] = [
    ...(primaryDescriptor === null
      ? []
      : [{ connectionState: "connected" as const, capabilities: primaryDescriptor.capabilities }]),
    ...Object.values(savedRuntimeById).map((runtime) => ({
      connectionState: runtime.connectionState,
      capabilities: runtime.descriptor?.capabilities ?? null,
    })),
  ];
  const commandAvailable = primaryDescriptor?.capabilities.runtime?.topology === "cloud-shell";
  return shouldShowPullRequestsNavigation(candidates, commandAvailable);
}
